import React, { useState } from 'react';
import { IoMdCloseCircle } from 'react-icons/io';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
interface SuccessPopUpProps {
    show: boolean;
    message: string;
    onConfirm: () => void; // Pass reason to onConfirm
    onCancel: () => void;
}

const SuccessPopUp: React.FC<SuccessPopUpProps> = ({
    show,
    message,
    onConfirm,
    onCancel,
}) => {
    if (!show) {
        return null;
    }
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-4 rounded-lg shadow-lg text-center relative w-96 h-52">
                <button
                    className="absolute top-0 right-0 mt-2 mr-2 !text-black"
                    onClick={onCancel}
                    aria-label="close"
                >
                    <IoMdCloseCircle className="!text-lg" />
                </button>
                <div className="my-2">
                    <div className="flex flex-col items-center">
                        <div className="mb-3">
                            <IoIosCheckmarkCircleOutline className="!text-green !text-6xl" />
                        </div>
                        <p className="mb-4 text-light_grey font-bold text-sm mx-5">
                            {message}
                        </p>
                    </div>
                    <div className="flex justify-center">
                        <button
                            onClick={onConfirm}
                            className="!bg-primary text-white font-bold text-sm py-2 px-1 mr-5 w-28 rounded"
                        >
                            {t('go_to_profile')}
                        </button>
                        <button
                            onClick={onCancel}
                            className="!bg-palladium text-white font-bold text-sm py-2 px-1 w-28 rounded"
                        >
                            {t('go_back')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuccessPopUp;
